<template>
    <div class="panel scheduler-panel" :class="'panel-' + scheduler.state.cssClass">
        <div class="panel-heading">
            <h4>{{ scheduler.type.name }}
                <button type="button" class="close" @click="hide()"><span>×</span></button>
            </h4>
            <div class="scheduler-data">state: <strong>{{ scheduler.state.name }}</strong></div>
            <div class="scheduler-data">steps: <strong>{{ scheduler.elapsedSteps }}</strong></div>
        </div>
        <ul class="list-group">
            <executor v-for="executor in scheduler.executors" :executor="executor" :last="scheduler.lastExecutor == executor" :next="scheduler.nextExecutor == executor"></executor>
        </ul>
    </div>
</template>

<script>

    import executor from 'components/workbench/simulator/schedulerPanel/Executor'; 

    export default {
        name: "schedulerPanel",
        props: ["scheduler"],
        data() {
            return {
            }
        },
        mounted() {
        },
        methods: {
            hide() {
                this.scheduler.session.showScheduler = false;
            }
        },
        watch: {
        },
        components: {
            executor
        },
        computed: {
        }
    }
</script>

<style scoped>
    div.scheduler-panel {
        float: right;
        width: 256px;
    }
    div.scheduler-data {
        font-size: small
    }
    div.scheduler-panel ul {
        max-height: 420px;
        overflow-y: auto;
    }
</style>


// WEBPACK FOOTER //
// SchedulerPanel.vue?2a7b984a